import { z } from 'zod';
/**
 * Khảo cổ quyết định — APM-AI-i (`plan-ai-features.md` mục 8).
 *
 * Câu hỏi nó trả lời: "vì sao hồi đó ta chọn X?". Người hỏi thường là người mới,
 * và thứ họ cần không phải một câu trả lời hay mà là **đường đi tới bản ghi
 * gốc**: quyết định nào, ghi lúc nào, dự án lúc ấy đang ra sao.
 *
 * `replayAsOf` tồn tại vì thế: nó mở màn hình Replay đúng tại thời điểm quyết
 * định, để người đọc tự thấy bối cảnh thay vì tin lời kể.
 */
export const DecisionSource = z.object({
    kind: z.enum(['raid', 'comment', 'document', 'event']),
    id: z.string().min(1).max(64),
});
export const DecisionAnswer = z.object({
    /** Câu trả lời, vài câu. Không có căn cứ thì nói thẳng là không có. */
    answer: z.string().min(1).max(3_000),
    /** Decision trong RAID khớp câu hỏi. `null` khi không tìm thấy cái nào. */
    decisionId: z.uuid().nullable(),
    /** Mốc dùng để dựng bối cảnh — ngày quyết định, hoặc mốc gần nhất tìm được. */
    contextAt: z.iso.datetime().nullable(),
    sources: z.array(DecisionSource).max(20),
    /**
     * Khi **không** có Decision nào khớp: đề xuất ghi hồi tố một cái.
     *
     * Đây là phần duy nhất của skill này đề nghị thay đổi dữ liệu, nên nó đi qua
     * đúng cửa như mọi gợi ý khác — người duyệt bấm, không phải AI ghi. Một quyết
     * định quan trọng mà không ai ghi lại là lỗ hổng thật của dự án; chỗ phát hiện
     * ra nó tự nhiên nhất là lúc có người đi tìm mà không thấy.
     */
    suggestBackfill: z
        .object({ title: z.string().min(1).max(300), rationale: z.string().min(1).max(1_000) })
        .nullable(),
});
//# sourceMappingURL=ai-decision.js.map